import type { HTMLAttributeAnchorTarget } from 'react';
import type { ButtonProps } from '@mui/material';
import { Button } from '@mui/material';

export type PpPrimaryButton = ButtonProps & {
  target?: HTMLAttributeAnchorTarget | undefined;
};

export function PrimaryButton(props: PpPrimaryButton): React.ReactElement {
  return <Button fullWidth color="primaryDark" size="large" variant="contained" {...props} />;
}
